import axios from 'axios';
import { AllDepartmentsResponseModel, EmployeeBuyerMappingModels, EmployeeBuyerMapppingResponseModel, EmployeeBuyerMappingActivateReq, BuyerID, CommonResponseModel } from '@project-management-system/shared-models';
import { CommonAxiosService } from '../common-axios-service-prs';

export class EmployeeBuyerMappingService extends CommonAxiosService{
    URL ="/employee_buyer_mapping";

  async createEmployeeBuyerMapping(depart?: EmployeeBuyerMappingModels): Promise<EmployeeBuyerMapppingResponseModel> {
    console.log(this.URL + "/createEmployeeBuyerMapping", depart,"sharefsedvbb");
    
        return  this.axiosPostCall(this.URL + "/createEmployeeBuyerMapping", depart)
    }
  

  async updateEmployeeBuyerMapping(department: EmployeeBuyerMappingModels): Promise<EmployeeBuyerMapppingResponseModel> {
    return this.axiosPostCall(this.URL + '/updateEmployeeBuyerMapping', department)
      
  }

  async getAllEmployees(req?:BuyerID): Promise<EmployeeBuyerMapppingResponseModel> {
    return this.axiosPostCall(this.URL + '/getAllEmployees',req)
                 
    }

  async activateOrDeactivateEmployeeBuyer(departmentsDtos: EmployeeBuyerMappingActivateReq): Promise<AllDepartmentsResponseModel> {
    console.log(departmentsDtos);
    return this.axiosPostCall(this.URL + '/activateOrDeactivateEmployeeBuyer', departmentsDtos)
     
  }

  async getAllActiveBuyers(req?:BuyerID): Promise<EmployeeBuyerMapppingResponseModel> {
    return this.axiosPostCall(this.URL + '/getAllActiveBuyers',req)
      
  }

  async getAllEmployeeMapping(req:BuyerID): Promise<EmployeeBuyerMapppingResponseModel> {
    console.log(req,'yyyyyyyyyyyyyyyyy')
    return this.axiosPostCall(this.URL + '/getAllEmployeeMapping',req)
      
  }

  async getMappedBuyers(req:BuyerID): Promise<CommonResponseModel> {
    console.log(req,'yyyyyyyyyyyyyyyyy')
    return this.axiosPostCall(this.URL + '/getMappedBuyers',req)
      
  }

}